import { S as Swiper } from './swiper-core-DH3mE4MZ.js';
import { N as Navigation } from './navigation-hpH59l-7.js';
import { A as A11y } from './a11y-DWSxD09z.js';
import './create-element-if-not-defined-DmoqEVgJ.js';

class FeaturedProductsAlt extends HTMLElement {
  swiper = this.querySelector('.swiper');
  nextButton = this.querySelector('.swiper-button-next');
  prevButton = this.querySelector('.swiper-button-prev');

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Navigation],
      slidesPerView: 1.4,
      spaceBetween: 1,
      lazyPreloadPrevNext: 2,
      loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }
}

customElements.define('featured-products-alt', FeaturedProductsAlt);
